import { ACCENT, MUTED, type IllustrationProps } from './types';

/**
 * IllustrationBinders — empty-state art for raw-card binders.
 *
 * Depicts: an open binder with a 3x3 nine-pocket sleeve grid on the right
 * page and binding rings on the spine.
 *
 * Resource: binders. Shell: any.
 */
export function IllustrationBinders({ size = 120, className, style }: IllustrationProps) {
  const h = (size * 90) / 120;
  return (
    <svg
      width={size}
      height={h}
      viewBox="0 0 120 90"
      fill="none"
      className={className}
      style={style}
      aria-hidden="true"
    >
      <ellipse cx="60" cy="80" rx="42" ry="3" stroke={MUTED} strokeWidth={1.5} />
      <path
        d="M16 20 L60 16 L60 76 L16 72 Z"
        stroke={MUTED}
        strokeWidth={1.5}
        strokeLinejoin="round"
      />
      <path
        d="M104 20 L60 16 L60 76 L104 72 Z"
        stroke={ACCENT}
        strokeWidth={1.5}
        strokeLinejoin="round"
      />
      <line x1="60" y1="16" x2="60" y2="76" stroke={ACCENT} strokeWidth={1.5} />
      {/* 3x3 pockets on right page */}
      {[0, 1, 2].map((col) =>
        [0, 1, 2].map((row) => (
          <rect
            key={`${col}-${row}`}
            x={66 + col * 11}
            y={22 + row * 16}
            width="9"
            height="13"
            rx="1"
            stroke={ACCENT}
            strokeWidth={1.2}
          />
        )),
      )}
      {/* binding rings */}
      <circle cx="60" cy="28" r="1.8" stroke={MUTED} strokeWidth={1.2} />
      <circle cx="60" cy="46" r="1.8" stroke={MUTED} strokeWidth={1.2} />
      <circle cx="60" cy="64" r="1.8" stroke={MUTED} strokeWidth={1.2} />
    </svg>
  );
}
